import React from 'react';

import { Loader } from '@change-corgi/design-system-legacy/components/progressiveDisclosure';

import { usePetitionDetailsPageData } from 'src/app/pages/petitionDetails/pageContext';
import { EndorsementCard, useEndorsements } from 'src/app/shared/components/endorsements';

type Props = {
	showAll?: boolean;
};

export const EndorsementsList: React.FC<Props> = ({ showAll = false }) => {
	const {
		data: { petition },
	} = usePetitionDetailsPageData();

	const {
		data: { endorsements, isLoading, error },
	} = useEndorsements({ petitionSlugOrId: petition.id });

	if (isLoading) {
		return <Loader size="m" my={64} mx="auto" />;
	}

	if (error) {
		return <div className="text-typography-weak">Failed to load endorsements</div>;
	}

	if (endorsements.length === 0) {
		return null;
	}

	// Sort: endorsements with description/content first
	const sortedEndorsements = [...endorsements].sort((a, b) => {
		if (a.content && !b.content) return -1;
		if (!a.content && b.content) return 1;
		return 0;
	});

	const endorsementsToShow = showAll ? sortedEndorsements : sortedEndorsements.slice(0, 3);

	return (
		<div className="flex flex-col gap-6">
			{endorsementsToShow.map((endorsement) => (
				<EndorsementCard
					key={endorsement.id}
					name={endorsement.name}
					title={endorsement.title ?? ''}
					description={endorsement.content ?? ''}
					photoUrl={endorsement.photo?.userSmall.url ?? ''}
					link={endorsement.url ?? undefined}
				/>
			))}
		</div>
	);
};
